<div class="sound-container">
  <input type="range" [(ngModel)]="volume" min="0" max="100" />
  <br />
  Volumex: {{ volume }}
  <br />
  <br />
  <button type="button" style="margin-right: 5vw" (click)="play('wav')">Play WAV</button>
  <button type="button" style="margin-right: 1vw" (click)="play('mp3')">Play MP3</button>
</div>
